import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/indexCustomDataContext';


interface ServiceHomePart4Props {
}


const HomePart5: React.FC<ServiceHomePart4Props> = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const { getValue } = useCustomData();
    const indexThirdTitle = getValue('indexThirdTitle');
    const indexThirdntroduceFirstTitle = getValue('indexThirdntroduceFirstTitle');
    const indexThirdntroduceSecondTitle = getValue('indexThirdntroduceSecondTitle');
    const indexThirdntroduceThirdTitle = getValue('indexThirdntroduceThirdTitle');
    const indexThirdntroduceFourthTitle = getValue('indexThirdntroduceFourthTitle');

    const indexThirdntroduceFirstContent = getValue('indexThirdntroduceFirstContent');
    const indexThirdntroduceSecondContent = getValue('indexThirdntroduceSecondContent');
    const indexThirdntroduceThirdContent = getValue('indexThirdntroduceThirdContent');
    const indexThirdntroduceFourthContent = getValue('indexThirdntroduceFourthContent');
    const indexThirdntroduceFourthContent4 = getValue('indexThirdntroduceFourthContent4');

    const renderSplitLines = (value: string | undefined) => {
        if (!value) return null;
        return value.split(',').map((line, index) => (
            <div key={index}>{line.trim()}</div>
        ));
    };


    return (
        <div className='home-home-part4'>
            <div className='home-home-part4-inner'>
                <div className="home-part4-h1">{indexThirdTitle}</div>
                <div className="home-part4-item">
                    <div className="home-part4-inner-item">
                        <p className='home-part4-inner-item-first' style={{ color: themeColor }}>{indexThirdntroduceFirstTitle}</p>
                        <div className='home-part4-line'></div>
                        <div className='home-part4-inner-item-second'>{renderSplitLines(indexThirdntroduceFirstContent)}</div>
                    </div>
                    <div className="home-part4-inner-item">
                        <p className='home-part4-inner-item-first' style={{ color: themeColor }}>{indexThirdntroduceSecondTitle}</p>
                        <div className='home-part4-line'></div>
                        <div className='home-part4-inner-item-second'>{renderSplitLines(indexThirdntroduceSecondContent)}</div>
                    </div>
                    <div className="home-part4-inner-item">
                        <p className='home-part4-inner-item-first' style={{ color: themeColor }}>{indexThirdntroduceThirdTitle}</p>
                        <div className='home-part4-line'></div>
                        <div className='home-part4-inner-item-second'>{renderSplitLines(indexThirdntroduceThirdContent)}</div>
                    </div>
                    <div className="home-part4-inner-item">
                        <p className='home-part4-inner-item-first' style={{ color: themeColor }}>{indexThirdntroduceFourthContent4}</p>
                        <div className='home-part4-line'></div>
                        <div className='home-part4-inner-item-second'>{renderSplitLines(indexThirdntroduceFourthContent)}</div>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default HomePart5;
